import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=2cb152a6&"
import script from "./Downloads.vue?vue&type=script&lang=js&"
export * from "./Downloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartBookDownloadButton: require('/opt/build/repo/components/Cart/BookDownloadButton.vue').default})
